import { Product } from "../../../contexts/cartContext/cartType";
import api from "../../../services/api";


interface CalculateDiscountResponse {
    success: boolean;
    discountedProducts: Product[];
    totalDiscount: number;
    errorMsg?: string;
}


export async function calculateNinegridDiscount(
    couponData: { nameCoupom: string; valueDiscount: string; percentageDiscount: string },
    products: Product[],
    token: string,
    pluginspaceId?: number
): Promise<CalculateDiscountResponse> {
    try {
        // Transformar produtos para formato esperado pelo motor
        const productsToGiveDiscout = products.map((product) => ({
            hash: window.btoa(product.code),
            id: product.id,
            productName: product.name,
            promotionalPrice: product.promotionalPrice,
            image: product.image,
            stock: product.stock,
            code: product.code,
            locationId: product.locationId,
            quantity: product.quantity,
            oldDiscountPrice: product.oldDiscountPrice
                ? product.oldDiscountPrice
                : product.promotionalPrice,
            price: parseInt((product.unitPrice * 100).toFixed(0)),
            unitPrice: parseInt((product.unitPrice * 100).toFixed(0)),
            codFilial: pluginspaceId,
            discountValue: 0,
            discountPercentageValue: 0,
            info: "",
            chair: "",
            notes: "",
            productSku: product.sku,
            measures: product.measures,
            variation: Object.entries(product.variation).map((obj) => ({
                grid: obj[0],
                value: obj[1],
            })),
        }));

        const payload = {
            couponPromotionalCode: couponData.nameCoupom,
            totalAmountDiscount: parseFloat(couponData.valueDiscount),
            percentageDiscountTotalAmount: parseFloat(couponData.percentageDiscount),
            discountGeneral: 0,
            products: productsToGiveDiscout,
        };

        try {
            const response = await api.post(
                "/api/discount-enginer/calcpaymentdiscount",
                payload,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            if (response.data) {
                const data = response.data.data.data;
                let totalDescontoCupom = 0;

                if (data.totalAmountDiscount) {
                    totalDescontoCupom = data.totalAmountDiscount;
                } else if (data.percentageDiscountTotalAmount) {
                    const totalDesconto = data.products.reduce(
                        (total: number, product: any) => {
                            if (product.price !== product.unitPrice) {
                                const totalProdutoPreco =
                                    product.unitPrice * product.quantity;
                                const descontoProdutoTotal = product.price;
                                const descontoPorProduto =
                                    totalProdutoPreco - descontoProdutoTotal;
                                return total + descontoPorProduto;
                            }
                            return total;
                        },
                        0
                    );
                    totalDescontoCupom = parseFloat((totalDesconto / 100).toFixed(2));
                }

                // Mapear produtos descountados de volta para o formato Product
                const discountedProducts: Product[] = data.products.map(
                    (discountProduct: any) => {
                        const originalProduct = products.find(
                            (p) => p.id === discountProduct.id
                        );
                        if (!originalProduct) return null;
                        const valueToDiscount = originalProduct.cupomDiscount ?? originalProduct.oldDiscountPrice ?? originalProduct.promotionalPrice ?? originalProduct.unitPrice ?? 0;



                        return {
                            ...originalProduct,
                            promotionalPrice: discountProduct.promotionalPrice,
                            oldDiscountPrice:
                                originalProduct.promotionalPrice ||
                                originalProduct.oldDiscountPrice ||
                                originalProduct.unitPrice,
                            withDiscout: true,
                        };
                    }
                ).filter(Boolean) as Product[];

                return {
                    success: true,
                    discountedProducts,
                    totalDiscount: totalDescontoCupom,
                };
            }

            return {
                success: false,
                discountedProducts: [],
                totalDiscount: 0,
                errorMsg: "Cupom não foi aplicado",
            };
        } catch (err) {
            return {
                success: false,
                discountedProducts: [],
                totalDiscount: 0,
                errorMsg: "Cupom não foi aplicado",
            };
        }
    } catch (error) {
        return {
            success: false,
            discountedProducts: [],
            totalDiscount: 0,
            errorMsg: "Erro ao calcular desconto",
        };
    }
}